import { Storage } from "aws-amplify";
import Decimal from "decimal.js";
import { isArray, isEqual, isPlainObject, reduce } from "lodash";
import moment from "moment-timezone";
import { systemDefaultTimeZone } from "./constant";

export function isIPAddress(ipaddress) {
  const ipAdd = ipaddress?.split(":")[0] || "";
  if (
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ipAdd
    )
  ) {
    return true;
  }
  return false;
}

export const getGlobalSearchFilteredData = (allData = [], filter) => {
  if (filter)
    return allData.filter((data) =>
      filter.keys.some((key) => {
        if (data[key]) {
          if (typeof data[key] === "string")
            return data[key]
              ?.toUpperCase()
              .includes(filter.keyword.toUpperCase());
          else if (Array.isArray(data[key])) {
            return data[key].some((d) =>
              d.toUpperCase().includes(filter.keyword.toUpperCase())
            );
          }
        }

        return false;
      })
    );

  return allData;
};

export function getTimeFromMins(mins) {
  if (mins >= 24 * 60 || mins < 0) {
    throw new RangeError(
      "Valid input should be greater than or equal to 0 and less than 1440."
    );
  }
  var h = (mins / 60) | 0,
    m = mins % 60 | 0;
  return moment
    .utc()
    .hours(h)
    .minutes(m)
    .format("hh:mm A");
}

export function cleanObject(obj) {
  const cloneOb = JSON.parse(JSON.stringify(obj || {}));
  for (let propName in cloneOb) {
    if (
      cloneOb[propName] === null ||
      cloneOb[propName] === undefined ||
      cloneOb[propName] === "" ||
      cloneOb[propName] === "|" ||
      (typeof cloneOb[propName] == "object" &&
        Object.keys(cloneOb[propName]).length === 0)
    ) {
      delete cloneOb[propName];
    }

    if (typeof cloneOb[propName] == "string" && cloneOb[propName] !== "") {
      cloneOb[propName] = cloneOb[propName].trim();
    }
  }
  return cloneOb || {};
}

export const getLodashDiff = (obj1, obj2) => {
  const obj1Copy = JSON.parse(JSON.stringify(obj1 || {}));
  return reduce(
    obj1Copy,
    function (result, value, key) {
      if (isPlainObject(value)) {
        result[key] = getLodashDiff(value, obj2[key]);
      } else if (
        isArray(value) &&
        !isEqual([...value].sort(), [...obj2[key]].sort())
      ) {
        result[key] = value;
      } else if (!isArray(value) && !isEqual(value, obj2[key])) {
        if (value === "") {
          result[key] = null;
        } else result[key] = value;
      }
      return result;
    },
    {}
  );
};

export const getCurrentDateTime = (
  dateOb,
  withSeconds = false,
  withTime = true
) => {
  if (withTime)
    return `${(dateOb.getMonth() + 1).toString().padStart(2, "0")}/${dateOb
      .getDate()
      .toString()
      .padStart(2, "0")}/${dateOb.getFullYear()}  ${formatAMPM(
        dateOb,
        withSeconds
      )}`;
  else
    return `${(dateOb.getMonth() + 1).toString().padStart(2, "0")}/${dateOb
      .getDate()
      .toString()
      .padStart(2, "0")}/${dateOb.getFullYear()}`;
};

export const getCurrentDateTimeNew = (
  dateOb,
  withSeconds = false,
  withTime = true
) => {
  if (withTime)
    return `${(dateOb.getMonth() + 1).toString().padStart(2, "0")}/${dateOb
      .getDate()
      .toString()
      .padStart(2, "0")}/${dateOb.getFullYear()}  ${formatAMPM(
        dateOb,
        withSeconds
      )}`;
  else
    return `${(dateOb.getMonth() + 1).toString().padStart(2, "0")}/${dateOb
      .getDate()
      .toString()
      .padStart(2, "0")}/${dateOb.getFullYear()}`;
};

export const formatAMPM = (dateOb, withSeconds) => {
  let hours = dateOb.getHours();
  let minutes = dateOb.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes.toString().padStart(2, "0");

  if (withSeconds) {
    const seconds = dateOb
      .getSeconds()
      .toString()
      .padStart(2, "0");
    return hours + ":" + minutes + ":" + seconds + " " + ampm;
  }

  return hours + ":" + minutes + " " + ampm;
};

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function textToClipboard(text) {
  let dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener("click", clickHandler);
    }, 150);
  };
  a.addEventListener("click", clickHandler, false);
  a.click();
  return a;
}

export const downloadFileFromS3 = async (fileKey, fileName, dispatch, generalActions) => {
  try {
    const result = await Storage.get(`${fileKey}`, {
      download: true,
    });
    downloadBlob(result.Body, fileName);
  } catch (error) {
    let ErrorMsg = error === "NoSuchKey: NoSuchKey" ? "No File Exist" : error;
    dispatch && dispatch(
      generalActions.pushNewAlert({
        show: true,
        heading: "Error",
        message: `Can't Download File: ${ErrorMsg}`,
        type: "danger",
      })
    );
    console.error(error);
  }
};

export function dollarSignValue(value, showMaxfractionDigits) {
  if (isNaN(value)) {
    return new Intl.NumberFormat("en-US", { style: 'currency', currency: 'USD' }).format(0);;
  }

  const minimumFractionDigits = showMaxfractionDigits ? (Number(value)?.toString())?.split('.')?.[1]?.length > 2 ? (Number(value)?.toString())?.split('.')?.[1]?.length : 2 : 2;
  // return new Intl.NumberFormat("en-US", { style: 'currency', currency: 'USD' }).format(Number(value));
  return new Intl.NumberFormat("en-US", { style: 'currency', minimumFractionDigits, currency: 'USD' }).format(Number(value));
}

export function formattedDateTime(date) {
  return moment(new Date(date)).format("MM/DD/YYYY HH:mm:ss");
}
export function formattedDate(date) {
  return moment(new Date(date)).format("MM/DD/YYYY");
}

export const LBS_TO_KG_CONVERSIONVALUE = 0.45359237;//0.453592 

export function kGtoLBSConversion(value) {
  if (value?.toString()) return (Number(value) * LBS_TO_KG_CONVERSIONVALUE);
}
export function LBStoKGConversion(value) {
  if (value?.toString()) return (Number(value) / LBS_TO_KG_CONVERSIONVALUE);
}

export function decimalToFixedValue(value, digit = 3) {
  return Number(Number(value).toFixed(digit));
}

export const convertValues = (value, conversionFunction, digit = 3) => {
  if (value && value !== "") {
    return {
      convertValue: isNaN(conversionFunction(value?.convertValue)) ? "" : conversionFunction(value?.convertValue),
      displayValue: isNaN(Number(Number(conversionFunction(value?.convertValue)).toFixed(digit))) ? "" : Number(Number(conversionFunction(value?.convertValue)).toFixed(digit))
    };
  }
  else {
    return {
      convertValue: "",
      displayValue: ""
    };
  }
};

export const dateAndTimeWithTimeZone = (date) => {
  return moment(date).format('yyyy-MM-DDTHH:mm:ssZ');
};

export const formattedDateWithTimeZone = (date) => {
  return moment(date).format('YYYY-MM-DDZ');
};

export const numberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export const currentLocalTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const hasValue = (value) => {
  return value !== null && value !== undefined && value.toString().trim() !== '';
};
export const blobToPrintPdf = function (eventBlob, isTabletMode) {
  var blob = new Blob([eventBlob], { type: 'application/pdf' });
  var blobURL = URL.createObjectURL(blob);
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (-1 !== ua.toLowerCase().indexOf('crios') || -1 !== ua.toLowerCase().indexOf('fxios') ||
    /mobile/i.test(ua) || /tablet/i.test(ua) || /iPad/i.test(ua) ||
    (/safari/.test(ua) && !/chrome/.test(ua) && !/crios/.test(ua)) || isTabletMode
  ) {
    window.open(blobURL, '_blank');
  } else {
    let iframe = document.createElement('iframe');
    document.body.appendChild(iframe);

    iframe.style.display = 'none';
    iframe.src = blobURL;
    iframe.onload = function () {
      setTimeout(function () {
        iframe.focus();
        iframe.contentWindow.print();
      }, 1);
    };
  }
};

export const handleBlobOpenInNewTab = (eventBlob) => {
  var blob = new Blob([eventBlob], { type: 'application/pdf' });
  var blobURL = URL.createObjectURL(blob);
  window.open(blobURL, '_blank');

};

export const bentWeightConstantValue = (isWeightKG) => {
  return {
    0: isWeightKG ? 0.003 : 0.006,
    1: isWeightKG ? 0.005 : 0.011,
    2: isWeightKG ? 0.0021 : 0.005,
    3: isWeightKG ? 0.006 : 0.012,
    4: isWeightKG ? 0.011 : 0.025,
    5: isWeightKG ? 0.008 : 0.018,
    6: isWeightKG ? 0.023 : 0.05,
  };
};

export const getUniqueValueFormArr = (arr) => {
  if (arr.length > 0 && Array.isArray(arr)) {
    const arrSet = new Set(arr);
    const uniqueControlIDArr = arrSet?.size && [...arrSet];
    return uniqueControlIDArr;
  } else {
    return arr;
  }
};

export const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

export const isMixedProduct = (denom) => {
  return denom === "Mixed";
};

export const decimaljsSum = (num1, num2) => {
  const num = new Decimal(num1 || 0);
  const sum = num.plus(num2 || 0);

  return sum?.toNumber();
};

export const decimaljsSubtraction = (num1, num2) => {
  const num = new Decimal(num1 || 0);
  const sub = num.sub(num2 || 0);

  return sub?.toNumber();
};

export const base64ToBlob = (base64Data, contentType = "image/png") => {
  const byteCharacters = atob(base64Data.split(",")[1]);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};


export const getPrevieImgeUrlFromS3 = async (imageUrlArr) => {
  const validItems = imageUrlArr?.filter((v) => v?.path) || [];

  const previewPromises = validItems.map(async (item) => {
    try {
      const res = await Storage.get(item.path, { download: true });
      return {
        name: item.name,
        data: res?.Body,
      };
    } catch (err) {
      console.error("S3 download failed", item.path, err);
      return {
        name: item.name,
        data: null,
      };
    }
  });

  return Promise.all(previewPromises);
};

export const fieldHasValue = (val) =>
  val !== null &&
  val !== undefined &&
  !(typeof val === 'string' && val.trim() === '') &&
  !(Array.isArray(val) && val.length === 0) &&
  !(typeof val === 'object' && !Array.isArray(val) && Object.keys(val).length === 0);


export const browserDatePstToUtc = (date) => {
  return moment(date).tz(systemDefaultTimeZone, true).utc();
};

export const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
